import { Select } from '@mui/material'
import { MenuItem } from '@vapor/material'
import { useCallback, useState, useEffect } from 'react'

export const colors: string[] = [
  '#f44336',
  '#e91e63',
  '#9c27b0',
  '#673ab7',
  '#3f51b5',
  '#2196f3',
  '#03a9f4',
  '#00bcd4',
  '#009688',
  '#4caf50',
  '#8bc34a',
  '#cddc39',
  '#ffeb3b',
  '#ffc107',
  '#ff9800',
  '#ff5722',
]

export type ColorPickerProps = {
  value?: string | null
  onChange?: (value: string | null) => void
  variant?: 'standard' | 'outlined'
  disableUnderline?: boolean
  disabled?: boolean
}

export default function ColorPicker({ value, onChange, variant, disableUnderline, disabled }: ColorPickerProps) {
  const [localValue, setLocalValue] = useState<string | null>(checkColor(value))

  const onLocalChange = useCallback(
    (color: string | null) => {
      const newLocalValue = checkColor(color)
      if (value === undefined) {
        if (newLocalValue !== localValue) {
          setLocalValue(newLocalValue)
          onChange?.(newLocalValue)
        }
      } else {
        if (newLocalValue !== value) {
          onChange?.(newLocalValue)
        }
      }
    },
    [localValue, value],
  )

  useEffect(() => {
    if (value !== undefined) {
      const newValue = checkColor(value)
      if (newValue !== localValue) {
        setLocalValue(newValue)
      }
    }
  }, [value])

  return (
    <Select //
      fullWidth
      value={localValue || ''}
      onChange={(event) => onLocalChange(event.target.value)}
      variant={variant}
      disableUnderline={disableUnderline}
      disabled={disabled}
    >
      {colors.map((color) => (
        <MenuItem key={color} value={color}>
          <div style={{ backgroundColor: color, width: '100%' }}>
            <div style={{ visibility: 'hidden' }}>{color}</div>
          </div>
        </MenuItem>
      ))}
    </Select>
  )
}

export function checkColor(color: any): string | null {
  if (!color || typeof color !== 'string') return null
  return colors.find((c) => c === color) || null
}
